import { EmptyCart, FilledCart } from "@/components/cart";
import { SchedulingBanner } from "@/components/scheduling/SchedulingBanner";
import { APP_HEADER_HEIGHT } from "@/components/ui";
import { recordStorefrontEvent } from "@/domain/storefront-analytics";
import { useCart } from "@/hooks/use-cart";
import { useOptimisticCart } from "@/hooks/use-optimistic-cart";
import { usePageBackground } from "@/hooks/use-page-background";
import { useEffect } from "react";

export function Cart() {
  const { loadInitialCart } = useCart()
  const { cart } = useOptimisticCart()
  usePageBackground()

  useEffect(() => {
    window.scrollTo(0, 0)
    loadInitialCart()
    recordStorefrontEvent({ type: "cart_view" })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div aria-hidden className={APP_HEADER_HEIGHT} />
      <SchedulingBanner />
      {cart.items.length ? <FilledCart /> : <EmptyCart />}
    </>
  )
}
